module.exports = __webpack_public_path__ + "img/code-ex.d0d8fdfe.png";